import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28349f6b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "setup-shop" }

import { ref, computed, nextTick, onMounted, watch } from 'vue'
import { throttle } from 'lodash'
import setupHead from './components/setupHead.vue'
import SwitchRam from './components/SwitchRam.vue'
import setupUser from './SetupUser.vue'
import setupPwd from './SetupPwd.vue'
import { getSubCustomer } from '@/apis/user'
import { confirmEdit } from '@/util/useConfirm'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { isD2C } from '@/store'
import { t } from '@/plugins/i18n'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const store = useStore()

const hideTab = computed(() => route.meta.hideTab)
const { customerShopId, customerId } = route.query
const main = computed(() => store.getters.user)
const sub = ref([])
const accounts: any = computed(() => {
  return [main.value, ...sub.value]
})
const account = ref()
const update = () =>
  getSubCustomer().then((res) => {
    if (res.success) {
      sub.value = res.data
    }
  })

update().then(() => {
  account.value = customerId ?? store.getters.user.customerId
})

const tabs = ref([
  { label: t('登录信息'), ctp: setupUser, name: 'SetupUser', account: true },
  { label: t('密码的新建/变更'), ctp: setupPwd, name: 'SetupPwd', account: true }
].filter((v: any) => !v.hidden))

const activeTab = ref(useRoute()?.query?.type ?? tabs.value[0].name)
const tabClick = async (tab: any) => {
  activeTab.value = tab.name
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(setupHead, {
      tabs: tabs.value,
      activeTab: activeTab.value,
      "onUpdate:activeTab": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
      onTabClick: tabClick
    }, null, 8, ["tabs", "activeTab"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (i) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: i.name
      }, [
        (account.value && i.name === activeTab.value)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(i.ctp), {
              key: account.value,
              class: "`setupRef`",
              onUpdate: update,
              account: account.value,
              "onUpdate:account": _cache[1] || (_cache[1] = ($event: any) => ((account).value = $event)),
              accounts: _unref(accounts),
              customer: _unref(accounts).find((v) => v.customerId === account.value)
            }, null, 8, ["account", "accounts", "customer"]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}
}

})